export class Cell {
    columnId: string;
    id: string;
    rowId: string;
    value: number;
}